import { Version } from './versionConfig.definition';
import type { VersionConfigDefinition } from './versionConfig.definition';

/**
 * Version configuration (runtime selection)
 *
 * This file is intentionally separated so that:
 * - Engineers can easily toggle versions without touching core definitions
 * - PR reviews for version changes remain small and focused
 * - Version switching is fast and low-risk
 *
 * IMPORTANT:
 * This file controls which design version is active for all users.
 * Every change should be reviewed carefully before deployment.
 *
 * How to switch versions:
 * 1. Edit the 'active' field below to Version.V2 or Version.V3
 * 2. Restart the dev server
 * 3. Changes take effect immediately (no rebuild needed)
 */
export const versionConfig = {
  active: Version.V2, // Switch to Version.V3 to enable the new design with left sidebar navigation
  description:
    'v2 (default) is the current production version. v3 introduces the new layout with left sidebar navigation and is currently under development.'
} as const satisfies VersionConfigDefinition;
